var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6364 3.78111H18.1259H14.3497V0.726562H5.28671V3.78111H1.51049H0V5.30838H1.51049V23.6357H18.1259V5.30838H19.6364V3.78111ZM6.7972 2.25384H12.8392V3.78111H6.7972V2.25384ZM16.6154 22.1084H3.02098V5.30838H5.28671H14.3497H16.6154V22.1084Z",
    fill: "#F35471"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79723 7.59766H5.28674V19.8158H6.79723V7.59766Z",
    fill: "#F35471"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5734 7.59766H9.06287V19.8158H10.5734V7.59766Z",
    fill: "#F35471"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3496 7.59766H12.8391V19.8158H14.3496V7.59766Z",
    fill: "#F35471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.34cbbcb8d6ff3cf3d78610c4aba3acb8.svg";
export { ForwardRef as ReactComponent };